import { QueryParamsEntities } from "@/domain/entities/MainApp";

export class RequestListLastBalanceV2 {
  actorType: "pos" | "client" | "client_cod" = "pos";
  page = 1;
  limit = 10;
  name = "";
  balanceStatus = "";
  balanceFrom = "";
  balanceTo = "";
  lastTrxDateFrom = "";
  lastTrxDateTo = "";
  sort = "";

  constructor(fields?: Partial<RequestListLastBalanceV2>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
